import { Component, Input, OnInit } from '@angular/core';
import { TagAppearanceET } from '@liberty-financial/ng-components/lib/components/tag/tag.enum';

@Component({
  selector: 'app-insight-card',
  templateUrl: './insight-card.component.html',
  styleUrls: ['./insight-card.component.scss']
})
export class InsightCardComponent implements OnInit {

  @Input() heading!: string;
  @Input() change!: number;
  @Input() text!: string;
  appearance: TagAppearanceET = 'default';

  constructor() { }

  ngOnInit(): void {
    this.appearance = this.change < 0 ? 'warning' : (this.change > 0 ? 'success' : 'default');
  }

  get sign(): string {
    return this.change > 0 ? '+' : '';
  }

}
